(function() {
  window.deltaCardService = {
    get(data) {
      return axios.get(`/api/delta_card/get.php`);
    },
    save(data) {
      return axios.post('/api/delta_card/save.php', data);
    },
    equip(data) {
      return axios.post('/api/user/card/equip_delta.php', data);
    }
  }
})();
